import summaryCommonStore from "@/store/summaryCommon.store";
import DocItem from "./DocItem";
import { useEffect, useMemo, useRef } from "react";
import summarySrcStore from "@/store/summarySrc.store";
import useWebOriginTextFollow from "@/sections/Summary/useOriginTextFollow";
import avPlayerStore from "@/store/avPlayer.store";

export default function DocComplete() {
  const detailInfo = summarySrcStore((state) => state.detailInfo);
  const getAvatar = summaryCommonStore((state) => state.getAvatar);
  const playingPi = avPlayerStore((state) => state.playingPi);

  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    summaryCommonStore.getState().setIsScrolled(false);
  }, []);

  const list = useMemo(() => {
    return detailInfo?.srcDoc?.pg || [];
  }, [detailInfo]);

  useWebOriginTextFollow({ records: list, scrollContainerRef });

  return (
    <div ref={scrollContainerRef}>
      {list?.map((item) => (
        <DocItem
          isPlaying={playingPi === item.pi}
          key={item.pi}
          item={item}
          avatarSrc={getAvatar(item.roleName)}
        />
      ))}
    </div>
  );
}
